export default () => `
<div class="small-container1 ">
        <div class="row1 row2">
            <h2 class="search-result">Search</h2>
        </div>
        <div class="row1 products-center">

        </div>
            <div class="pages-btn">
                <span>1</span>
                <span id="disabled-span">→</span>
            </div>
</div>`;
